<template>
    <div>
        <InputRadio
                v-model="addressModel.personType"
                key="input-address-person-type"
                :setValue="addressModel.personType"
                :inputLbl="lbl.tax.personType"
                :itemList="personTypeValue"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[0]"
        ></InputRadio>
        <div v-if="addressModel.personType == 'individual'">
            <InputRadio
                    key="input-address-title"
                    v-model="addressModel.title"
                    :setValue="addressModel.title"
                    :inputLbl="lbl.tax.title"
                    :itemList="prefixValue"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :errorInfo="errorInfo[1]"
            ></InputRadio>
            <InputText
                    v-model="addressModel.firstname"
                    inputId="input-address-firstname"
                    key="input-address-firstname"
                    :inputLbl="lbl.shipping.firstname"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :errorInfo="errorInfo[2]"
                    :onlyPersonName="true"
                    :inputMaxLength="45"
            ></InputText>
            <InputText
                    v-model="addressModel.lastname"
                    inputId="input-address-lastname"
                    key="input-address-lastname"
                    :inputLbl="lbl.shipping.lastname"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :errorInfo="errorInfo[3]"
                    :onlyPersonName="true"
                    :inputMaxLength="45"
            ></InputText>
        </div>
        <div v-if="addressModel.personType == 'company'">
            <InputText
                    v-model="addressModel.companyName"
                    inputId="input-address-company-name"
                    key="input-address-company-name"
                    :inputLbl="lbl.tax.companyName"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :errorInfo="errorInfo[4]"
                    :inputMaxLength="60"
            ></InputText>
        </div>
        <InputNumber
                v-model="addressModel.taxId"
                inputId="input-address-id-card"
                key="input-address-id-card"
                :inputLbl="lbl.shipping.nationalid"
                :inputMinLength="13"
                :inputMaxLength="13"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[5]"
        ></InputNumber>
        <InputContactNumber
                v-model="addressModel.contactNumber"
                inputId="address-contact-number"
                key="address-contact-number"
                delimeter="-"
                :inputLbl="lbl.shipping.contactnumber"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[6]"
        ></InputContactNumber>
        <InputEmail
                v-model="addressModel.email"
                inputId="input-address-email"
                key="input-address-email"
                :inputLbl="lbl.shipping.email"
                :inputMaxLength="50"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[7]"
        ></InputEmail>
        <InputText
                v-model="addressModel.building"
                inputId="input-address-building"
                key="input-address-building"
                :inputLbl="lbl.tax.building"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[8]"
                :inputMaxLength="50"
        ></InputText>
        <InputText
                v-model="addressModel.room"
                inputId="input-address-room"
                key="input-address-room"
                :inputLbl="lbl.tax.room"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[9]"
                :inputMaxLength="50"
        ></InputText>
        <InputNumber
                v-model="addressModel.floor"
                inputId="input-address-floor"
                key="input-address-floor"
                :inputLbl="lbl.tax.floor"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[10]"
                :inputMaxLength="20"
        ></InputNumber>
        <InputText
                v-model="addressModel.village"
                inputId="input-address-village"
                key="input-address-village"
                :inputLbl="lbl.tax.village"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[11]"
                :inputMaxLength="50"
        ></InputText>
        <InputNumber
                v-model="addressModel.number"
                inputId="input-address-number"
                key="input-address-number"
                :inputLbl="lbl.tax.number"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[12]"
                :inputMaxLength="20"
        ></InputNumber>
        <InputText
                v-model="addressModel.moo"
                inputId="input-address-moo"
                key="input-address-moo"
                :inputLbl="lbl.tax.moo"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[13]"
                :inputMaxLength="20"
        ></InputText>
        <InputText
                v-model="addressModel.soi"
                inputId="input-address-soi"
                key="input-address-soi"
                :inputLbl="lbl.tax.soi"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[14]"
                :inputMaxLength="50"
        ></InputText>
        <InputText
                v-model="addressModel.road"
                inputId="input-address-road"
                key="input-address-road"
                :inputLbl="lbl.tax.road"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[15]"
                :inputMaxLength="50"
        ></InputText>
        <FormAddressDropDown
                formId="form-address"
                :address="formAddressModel"
                :lblShipping="lbl.shipping"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :zipcodeError="errorInfo[16]"
                :provinceError="errorInfo[17]"
                :districtError="errorInfo[18]"
                :subDistrictError="errorInfo[19]"
        ></FormAddressDropDown>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";
import Locale from "@/helper/locale/Locale.js";
import FormHelper from "@/helper/FormHelper.js";
//component
import InputText from "@/components/Input/Text.vue";
import InputContactNumber from "@/components/Input/ContactNumber.vue";
import InputNumber from "@/components/Input/Number.vue";
import InputEmail from "@/components/Input/Email.vue";
import InputRadio from "@/components/Input/RadioBox.vue";
import FormAddressDropDown from "@/components/Form/FormAddressDropdown.vue";
//service
import { AddressModel } from "@/core/Address/model/AddressModel.js";
import { AddressListModel } from "@/core/Address/model/AddressListModel.js";

export default {
    name: "FormAddress",
    components: {
        InputText,
        InputContactNumber,
        InputNumber,
        InputEmail,
        InputRadio,
        FormAddressDropDown,
    },
    props: {
        address: Object,
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            isFirstSave: true,
            errorInfo: [],
            personTypeValue: [],
            prefixValue: [],

            formAddressModel: new AddressModel(),
            addressModel: new AddressListModel(),
        };
    },
    created: function() {
        if (this.address != null) {
            this.addressModel = {...this.address};
            this.formAddressModel.setValueFromAddressListModel(this.addressModel);
        }

        // console.log(this.addressModel);

        this.addressModel.setIsTax();
        this.setupForm();
    },
    methods: {
        setupForm: function() {
            var personType = new FormHelper.ItemListValue();
            personType.add("บุคคลธรรมดา", "individual");
            personType.add("นิติบุคคล", "company");
            this.personTypeValue = personType.getList();

            var prefixValue = new FormHelper.ItemListValue();
            prefixValue.add("นาย", "mr");
            prefixValue.add("นางสาว", "ms");
            prefixValue.add("นาง", "mss");
            this.prefixValue = prefixValue.getList();

            this.errorInfo = FormHelper.genErrorInfo(20);
        },
        submitForm: function() {
            this.isFirstSave = false;

            if (this.validate()) {
                this.addressModel.setValueFromAddressModel(this.formAddressModel);
                return this.addressModel;
            }
            return null
        },
        validate: function() {
            for (let i=0 ; i<20 ; i++) {
                if (this.addressModel.personType == 'individual') {
                    if (i == 4) {
                        continue;
                    }
                } else if (this.addressModel.personType == 'company') {
                    if (i >= 1 && i <= 3) {
                        continue;
                    }
                }

                if (!this.errorInfo[i].isValid) {
                    return false;
                }
            }

            return true;
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
</style>
